import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import { MKT_ADS_DESIGN as d } from '../MktAds.design';

export default function AdsScopeBanner({ capabilities, onReconnect }) {
    const { t } = useTranslation('marketing');

    // Nenhuma conta legível (sem conta ou sem escopo em todas) é caso do
    // AdsConnectHero, que substitui a tela inteira — aqui sobra só o meio
    // termo: parte das contas lê anúncios, parte não.
    if (!capabilities || !capabilities.needsReconnect || !capabilities.canReadAny) return null;

    const affected = (capabilities.accounts || []).filter((a) => !a.canReadAds);

    const title = affected.length === 1
        ? t('ads.scope.noPermission', { name: affected[0].account_name })
        : t('ads.scope.someMissing');

    return (
        <div className={d.capabilityBanner.container}>
            <Iconify icon="eva:alert-triangle-outline" width={20} className={d.capabilityBanner.icon} />
            <div className="flex-1 min-w-0">
                <p className={d.capabilityBanner.title}>{title}</p>
                <p className={d.capabilityBanner.subtitle}>
                    {t('ads.scope.subtitle')}
                </p>
            </div>
            <span className={d.capabilityBanner.action} onClick={onReconnect} role="button" tabIndex={0}>
                {t('ads.scope.updatePermissions')}
            </span>
        </div>
    );
}
